import { useCallback, useRef, useState } from 'react';

export const useSleep = () => {
    const [isSleeping, setIsSleeping] = useState(false);
    const timerRef = useRef<ReturnType<typeof globalThis.setTimeout> | null>(
        null
    );

    const sleep = useCallback(async (ms: number) => {
        setIsSleeping(true);

        return new Promise<void>((resolve) => {
            timerRef.current = globalThis.setTimeout(() => {
                setIsSleeping(false);
                resolve();
            }, ms);
        });
    }, []);

    return { sleep, isSleeping };
};
